import React, { useCallback, useState } from "react";
import { Bell, X } from "lucide-react";
import EventKeywordField from "./EventKeywordField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

export function EditEventPopup({ selectedEvent, closePopup, confirm }) {

    const [event, setEvent] = useState(selectedEvent);

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onContinueClick = () => {
        closePopup();
        confirm({ ...event, name: event.value });
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-edit-event-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(eventClick) => eventClick.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Bell size={18} />
                        </div>
                        <div>
                            <h4 id="oct-edit-event-title" className="oct-shared-popup__title">Edit Event</h4>
                            <p className="oct-shared-popup__subtitle">Adjust the keyword or pattern used to identify this event.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close edit event popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <EventKeywordField popup={true} required={true} value={event.value} onChange={(value) => setEvent({ ...event, value })} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!event.value}
                        onClick={onContinueClick}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )

}

export default EditEventPopup;
